import { render, staticRenderFns } from "./FormQuestionRadioButtonType.vue?vue&type=template&id=57c5fde4"
import script from "./FormQuestionRadioButtonType.vue?vue&type=script&lang=js"
export * from "./FormQuestionRadioButtonType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports